import { useMutation, useQueryClient } from 'react-query';
import OneAuthAPI, { HubspotContactInput } from 'services/API/OneAuthAPI';

export const HUBSPOT_CONTACTS_QUERY_KEY = 'hubspot-contacts';

/**
 * Creates a HubSpot contact for the given identity and refreshes the contacts
 * list on success so the new contact appears immediately.
 */
export const useCreateHubspotContact = (identity?: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (contact: HubspotContactInput) =>
      OneAuthAPI.createHubspotContact(identity as string, contact),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([HUBSPOT_CONTACTS_QUERY_KEY]);
      },
    },
  );
};
